import { previewKeyAtom } from 'js/file_viewer/core/atoms/atom';
import { usePreviewKeyAtomValue, useSetPreviewKeyAtom } from 'js/file_viewer/core/atoms/use_atom';
const localErrorAtom = previewKeyAtom(undefined);
/**
 * @returns
 *   An error that is not caused by bad server state, for a particular previewKey. For example, rendering errors. This
 *   value being populated is not a guarantee that it will be shown in the File Viewer. Final error state is a
 *   negotiation between this value and errors from server responses.
 *
 * If you are trying to determine if the File Viewer is in an error state, consult use*PreviewMetadata instead, which
 * reconciles local errors with server errors.
 */
export const useLocalErrorForPreviewKey = (previewKey) => {
    return usePreviewKeyAtomValue(localErrorAtom, previewKey);
};
export const useSetLocalErrorCallback = (previewKey) => {
    return useSetPreviewKeyAtom(localErrorAtom, previewKey);
};
//# sourceMappingURL=error.preenvesnextjs.map
